/**
 * Идентификаторите се раждат на телефона, не на сървъра — това е условието
 * опашката да работи офлайн и повторното изпращане да е безопасно.
 */

function randomHex(bytes: number): string {
  const buf = new Uint8Array(bytes);
  crypto.getRandomValues(buf);
  return Array.from(buf, (b) => b.toString(16).padStart(2, '0')).join('');
}

/** Ключ като `evt_lz4k9x_3f1a…` — четим в лог, достатъчно уникален (16 случайни байта). */
export function newId(prefix: string): string {
  return `${prefix}_${Date.now().toString(36)}_${randomHex(16)}`;
}

const DEVICE_KEY = 'kmdx.driver.deviceId';

/**
 * Идентификаторът на устройството оцелява презареждане и обновяване, но не и
 * изтриване на данните на браузъра — тогава шофьорът се свързва отново с код.
 */
export function getDeviceId(): string {
  const existing = localStorage.getItem(DEVICE_KEY);
  if (existing && existing.length >= 8) return existing;
  const created = `dev_${randomHex(16)}`;
  localStorage.setItem(DEVICE_KEY, created);
  return created;
}
